import { EqmMoldCleanDto, defaultEqmMoldCleanDto } from 'src/dtos/eqmMoldClean/eqmMoldCleanDto';
import { moldDto, defaultMoldDto } from 'src/dtos/mold/moldDto';

export interface EQM4010_R01HeaderDto extends moldDto {
	itemNm?: string;
}

export const defaultEQM4010_R01HeaderDto: EQM4010_R01HeaderDto = {
	...defaultMoldDto,
};

/**
 * 금형 세척 이력 데이터를 위한 내부 확장 인터페이스
 */
export interface EQM4010_R01DetailDto extends EqmMoldCleanDto {
	moldNm?: string;
	compNm?: string;
	cleanWorkerNm?: string;
	isDeleted?: boolean;
}

/**
 * 금형 세척 이력 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultEQM4010_R01DetailDto: EQM4010_R01DetailDto = {
	...defaultEqmMoldCleanDto,
	moldNm: '',
	compNm: '',
	cleanWorkerNm: '',
};
